// src/components/TerminosCondiciones.js
import React from "react";
import "../CSS/terminosCondiciones.css";

const TerminosCondiciones = () => {
  return (
    <main className="terminos-wrapper">
      <section className="terminos-card">
        <h1 className="terminos-title">Términos y Condiciones</h1>
        <p className="terminos-updated">
          Última actualización: 20 de Junio de 2026
        </p>

        <div className="terminos-section">
          <p>
            Bienvenido(a) a Komuness CR. Al acceder, navegar, registrarse o
            utilizar esta plataforma web, usted acepta expresamente los
            presentes Términos y Condiciones de Uso.
          </p>
        </div>

        <div className="terminos-section">
          <h2>1. DEFINICIONES</h2>
          <p>
            Para efectos de este documento:
            <br />
            Komuness CR se refiere a la plataforma digital y servicios
            relacionados; Usuario es cualquier persona que utilice la
            plataforma; Contenido comprende publicaciones, comentarios,
            imágenes, videos, enlaces, documentos y demás material compartido.
          </p>
        </div>

        <div className="terminos-section">
          <h2>2. ACEPTACIÓN OBLIGATORIA</h2>
          <p>
            El acceso y uso de la plataforma está condicionado a la aceptación
            total de estos Términos y Condiciones.
          </p>
        </div>

        <div className="terminos-section">
          <h2>2A. USO POR PERSONAS MAYORES DE EDAD</h2>
          <p>
            El usuario declara que cuenta con la capacidad legal necesaria para
            aceptar estos Términos y Condiciones y utilizar la plataforma. En
            caso de ser menor de edad, deberá contar con la autorización de su
            representante legal.
          </p>
        </div>

        <div className="terminos-section">
          <h2>3. RESPONSABILIDAD EXCLUSIVA DEL USUARIO</h2>
          <p>
            Cada usuario es responsable del contenido que publique, la
            información que comparta y las consecuencias derivadas de sus
            acciones.
          </p>
        </div>

        <div className="terminos-section">
          <h2>4. EXENCIÓN DE RESPONSABILIDAD DE KOMUNESS CR</h2>
          <p>
            Komuness CR actúa como una plataforma tecnológica de intermediación
            y publicación. Nada de lo dispuesto deberá interpretarse como una
            exoneración de responsabilidad en aquellos supuestos en que dicha
            exoneración no sea permitida por la legislación aplicable.
          </p>
        </div>

        <div className="terminos-section">
          <h2>5. CONTENIDO PROHIBIDO</h2>
          <p>
            Se prohíbe contenido ilegal, difamatorio, fraudulento,
            discriminatorio, violatorio de derechos de autor, privacidad o
            seguridad de terceros.
          </p>
        </div>

        <div className="terminos-section">
          <h2>6. RESPONSABILIDAD LEGAL DEL USUARIO</h2>
          <p>
            El usuario responderá por los daños que cause a terceros y mantendrá
            indemne a Komuness CR frente a reclamos derivados de sus
            actuaciones.
          </p>
        </div>

        <div className="terminos-section">
          <h2>7. MODERACIÓN Y ELIMINACIÓN DE CONTENIDO</h2>
          <p>
            Komuness CR podrá revisar contenido, eliminar publicaciones,
            suspender cuentas y colaborar con autoridades cuando corresponda.
          </p>
        </div>

        <div className="terminos-section">
          <h2>8. PRIVACIDAD Y DATOS</h2>
          <p>
            El tratamiento de los datos personales se realizará conforme a la
            legislación aplicable y la Política de Privacidad de Komuness CR.
          </p>
        </div>

        <div className="terminos-section">
          <h2>9. ENLACES Y SERVICIOS DE TERCEROS</h2>
          <p>
            Komuness CR no controla ni asume responsabilidad por servicios o
            contenidos de terceros.
          </p>
        </div>

        <div className="terminos-section">
          <h2>10. DISPONIBILIDAD DE LA PLATAFORMA</h2>
          <p>
            No se garantiza funcionamiento ininterrumpido ni ausencia de
            errores.
          </p>
        </div>

        <div className="terminos-section">
          <h2>11. PROPIEDAD INTELECTUAL</h2>
          <p>
            Los usuarios conservan los derechos sobre sus contenidos y autorizan
            su uso dentro de la plataforma para su operación.
          </p>
        </div>

        <div className="terminos-section">
          <h2>12. LIMITACIÓN DE RESPONSABILIDAD</h2>
          <p>
            En la medida permitida por la ley, Komuness CR no responderá por
            daños ocasionados por terceros o por el uso indebido de la
            plataforma.
          </p>
        </div>

        <div className="terminos-section">
          <h2>13. DENUNCIAS Y REPORTES</h2>
          <p>
            Komuness CR podrá revisar reportes y adoptar medidas razonablemente
            necesarias conforme a sus políticas y la legislación aplicable.
          </p>
        </div>

        <div className="terminos-section">
          <h2>14. MODIFICACIONES DE LOS TÉRMINOS</h2>
          <p>
            Komuness CR podrá modificar estos términos y comunicar cambios
            sustanciales por los medios que considere apropiados.
          </p>
        </div>

        <div className="terminos-section">
          <h2>15. LEGISLACIÓN APLICABLE</h2>
          <p>
            Estos términos se regirán por las leyes de la República de Costa
            Rica.
          </p>
        </div>

        <div className="terminos-section">
          <h2>16. ACEPTACIÓN DIGITAL</h2>
          <p>
            La aceptación mediante mecanismos electrónicos tendrá validez legal
            equivalente a una firma.
          </p>
        </div>

        <div className="terminos-section">
          <h2>17. CONTACTO</h2>
          <p>Correo: komunesscr@gmail.com | Sitio web: www.komunesscr.com</p>
        </div>
      </section>
    </main>
  );
};

export default TerminosCondiciones;
